<!--供应商管理列表  -->
<template>
    <div class="business-content-main" v-loading="saveLoading" element-loading-spinner="none">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="showSearchDialog">查询（F2）</el-button>
                <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary" @click="add(1)" v-if="permission.add">{{ permission.add }} (F3)</el-button>
                <el-button v-if="permission.applyAdvancePayment" size="small" type="primary" icon="el-icon-document-add" class="search-btn" @click="showApplyAdvance(false)">{{
                    permission.applyAdvancePayment
                }}</el-button>
                <el-button size="small" icon="el-icon-document-copy" class="search-btn btn-primary" @click="applyAdvancePayment()" v-if="permission.advanceRecords">{{
                    permission.advanceRecords
                }}</el-button>
                <el-button size="small" icon="el-icon-files" class="search-btn btn-primary" @click="gotoImportPage()" v-if="permission.importSupp">{{
                    permission.importSupp
                }}</el-button>
                <el-button size="small" type="warning" icon="el-icon-link" class="search-btn" @click="entityMerge()" v-if="permission.entityMerge">{{
                    permission.entityMerge
                }}</el-button>
                <el-button size="small" class="search-btn btn-primary" v-if="permission.exportSup" @click="exportForm">
                    <i class="fa fa-file-excel-o"></i>
                    {{ permission.exportSup }}</el-button
                >
                <el-button size="small" class="search-btn" type="primary" @click="bacthUpdate()" v-if="permission.bacthUpdate">{{ permission.bacthUpdate }}</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                :data="tableData"
                border
                style="width: 100%"
                @cell-dblclick="handleDBClick"
                :tableCode="tableCode"
                v-loading="loading"
                ref="multipleTable"
                row-key="getRowKey"
                @sort-change="sortChange"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" reserve-selection></el-table-column>
                <template v-for="(col,index) in columnShowSets">
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort?'custom':false"
                        header-align
                        :prop="col.ColumnCode"
                        v-if="col.ColumnCode == 'IsRecommend'"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            {{ scope.row.IsRecommend ? "是":"否" }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort?'custom':false"
                        header-align
                        :prop="col.ColumnCode"
                        v-else
                        show-overflow-tooltip
                    >
                    </el-table-column>
                </template>
                <el-table-column fixed="right" label="操作" :autoWidth="true" :isCanSet="true">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button v-if="permission.edit" title="编辑" size="mini" type="text" @click="add(2, scope.row)">{{ permission.edit }}</el-button>
                            <el-button v-if="permission.del" title="删除" style="color: red" size="mini" type="text" @click="del(scope.row)">{{ permission.del }}</el-button>
                            <el-button v-if="permission.payAccount" title="支付账号" size="mini" type="text" @click="payAccount(scope.row.EntpCusId)">{{
                                permission.payAccount
                            }}</el-button>
                            <el-button v-if="permission.advanceRecords" title="预付款数据" size="mini" type="text" style="color: orange" @click="applyAdvancePayment(scope.row)">{{
                                permission.advanceRecords
                            }}</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <el-dialog :close-on-click-modal="false" title="供应商信息" :visible.sync="dialogVisible" width="1000px">
            <div class="dialog-content" v-if="dialogVisible">
                <customerEdit ref="customerEdit" :cusId="entpCusId" :type="dialogType" @closeDialog="closeDialog" source="2"></customerEdit>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="供应商支付账号信息" :visible.sync="dialogAccountVisible" width="1000px">
            <div class="dialog-content" v-if="dialogAccountVisible">
                <payAccount ref="payAccount" :entpCusId="entpCusId" @closeDialog="closeAccountDialog"></payAccount>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="预付款数据" :visible.sync="dialogApplyVisible" width="1000px">
            <div class="dialog-content" v-if="dialogApplyVisible">
                <advancePayment ref="advanceReceipt" @closeReceipt="closeApplyDialog" :EntpCusId="entpCusId" :EntpCusName="EntpCusName"></advancePayment>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="供应商数据合并" :visible.sync="showEntityVisible" width="1000px">
            <div class="dialog-content" v-if="showEntityVisible">
                <entityMerge EntpCusId="" @closeDialog="closeDialog"></entityMerge>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            title="供应商搜索"
            :visible.sync="dialogSearchVisible"
            width="400px"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="search-sup-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -170px"
        >
            <div class="dialog-content" v-if="dialogSearchVisible">
                <el-form ref="form" label-position="left" label-width="70px">
                    <el-form-item label="供应商">
                        <el-select
                            ref="search_sup"
                            size="small"
                            v-model="searchData.Name"
                            remote
                            filterable
                            clearable
                            allow-create
                            placeholder="请输入供应商名称"
                            :remote-method="searchSupplier"
                            style="width: 100%"
                            v-select-scroll-more="searchSupplierLoad"
                        >
                            <el-option v-for="item in supplierOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="联系电话">
                        <el-input size="small" v-model="searchData.CallNum" v-filter-special-char="searchData.CallNum" placeholder="请输入联系电话"></el-input>
                    </el-form-item>
                    <el-form-item label="主营车型" v-if="isExObj('MainVehicle')">
                        <el-input size="small" v-model.trim="searchData.MainVehicle" v-filter-special-char="searchData.MainVehicle" placeholder="主营车型"></el-input>
                    </el-form-item>
                    <el-form-item label="主营配件" v-if="isExObj('MainPartName')">
                        <el-input size="small" v-model.trim="searchData.MainPartName" v-filter-special-char="searchData.MainPartName" placeholder="主营配件"></el-input>
                    </el-form-item>
                    <el-form-item label="简称" v-if="isExObj('Abbr')">
                        <el-input size="small" v-model="searchData.Abbr" v-filter-special-char="searchData.Abbr" placeholder="简称"></el-input>
                    </el-form-item>
                    <el-form-item label="地区" v-if="isExObj('Zone')">
                        <el-input size="small" v-model.trim="searchData.Zone" v-filter-special-char="searchData.Zone" placeholder="地区"></el-input>
                    </el-form-item>
                    <el-form-item label="类型标签" v-if="isExObj('Tags')">
                        <el-select style="width: 100%" size="small" filterable clearable v-model="searchData.Tags" @visible-change="tagVisibleChange($event)">
                            <el-option v-for="optionItem in tagsList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value"></el-option>
                        </el-select> </el-form-item
                    ><el-form-item label="跟进人" v-if="isExObj('Follower')">
                        <el-select
                            v-model="searchData.FollowerId"
                            style="width: 100%"
                            @visible-change="staffVisibleChange($event)"
                            filterable
                            placeholder="请选择"
                            size="small"
                            clearable
                        >
                            <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="创建日期" v-if="isExObj('CreateTime')">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="dateTimes1"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDate1TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="更新日期" v-if="isExObj('UpdateTime')">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="dateTimes2"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDate2TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                    <el-button size="small" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                    <el-button size="small" @click="closeSearchDialog">关闭（Esc）</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            title="预付款"
            :visible.sync="isShowAdvanceDialog"
            :append-to-body="true"
            v-dialog-drag
            :modal="false"
            width="400px"
            lock-scroll
            id="apply-dialog"
            style="margin-left: -100px"
        >
            <div v-if="isShowAdvanceDialog" class="settle-op-content">
                <ApplyAdvanceRAndP ref="applyAdvanceRAndP" @closeDialog="closeAdvanceDialog" :CType="1" :IsEdit="false"></ApplyAdvanceRAndP>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="批量修改" :visible.sync="isShowUpdate" width="450px" append-to-body :modal="false">
            <div class="dialog-content" v-if="isShowUpdate">
                <div class="flex" style="margin-bottom: 10px">
                    <div class="e-item1">
                        <div>修改项</div>
                        <div>
                            <el-select size="small" class="search-item" style="width: 110px" v-model="bacthUpdateData.UpdateKey" clearable placeholder="修改属性">
                                <el-option key="标签类型" label="标签类型" value="1"></el-option>
                                <el-option key="主营配件" label="主营配件" value="2"></el-option>
                                <el-option key="主营车型" label="主营车型" value="3"></el-option>
                                <el-option key="职位" label="职位" value="4"></el-option>
                                <el-option key="跟进采购员" label="跟进采购员" value="5"></el-option>
                                <el-option key="备注" label="备注" value="6"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="e-item2">
                        <div>结果值</div>
                        <div>
                            <el-select
                                style="width: 260px"
                                size="small"
                                v-if="bacthUpdateData.UpdateKey == '1'"
                                filterable
                                allow-create
                                clearable
                                v-model="bacthUpdateData.UpdateValue"
                                @visible-change="tagVisibleChange($event)"
                                placeholder="请选择标签类型"
                            >
                                <el-option v-for="optionItem in tagsList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value"></el-option>
                            </el-select>
                            <el-input
                                style="width: 260px"
                                size="small"
                                v-if="
                                    bacthUpdateData.UpdateKey == '' ||
                                    bacthUpdateData.UpdateKey == '2' ||
                                    bacthUpdateData.UpdateKey == '3' ||
                                    bacthUpdateData.UpdateKey == '4' ||
                                    bacthUpdateData.UpdateKey == '6'
                                "
                                v-model.trim="bacthUpdateData.UpdateValue"
                                v-filter-special-char="bacthUpdateData.UpdateValue"
                                placeholder="输入修改后的结果值"
                            ></el-input>
                            <el-select
                                v-model="bacthUpdateData.UpdateValue"
                                v-if="bacthUpdateData.UpdateKey == '5'"
                                style="width: 260px"
                                @visible-change="staffVisibleChange($event)"
                                filterable
                                placeholder="请选择采购跟进人"
                                size="small"
                                clearable
                            >
                                <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
                <div class="dialog-footer" style="text-align: right">
                    <el-button size="small" @click="closeUpdateDialog">取消</el-button>
                    <el-button class="btn-primary" size="small" @click="confirmUpdate">确定</el-button>
                </div>
            </div>
        </el-dialog>
        <el-progress type="circle" :percentage="percentage" class="saveProgress" :class="{ hide: !saveLoading }"></el-progress>
        <div style="z-index: 2001" class="exportmsg" v-if="showExportMsg">
            <span>数据已经准备好，正在生成Excel表格，可能耗时1-5min，请耐心等候……</span>
            <span>您也可以打开新的窗口进行其他的操作</span>
        </div>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import customerEdit from '@/components/business/customerManage/customerEdit';
import mixin from '@/mixins/mixin';
import breadcrumb from '@/components/common/breadcrumb';
import payAccount from '@/components/business/supplierManage/payAccount';
import advancePayment from '@/components/business/supplierManage/advancePayment';
import entityMerge from '@/components/business/customerManage/entitySupMerge';
import ApplyAdvanceRAndP from '@/components/business/revenue_h/applyAdvanceRAndP';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: {
        customerEdit,
        breadcrumb,
        elTableColumn,
        payAccount,
        advancePayment,
        entityMerge,
        ApplyAdvanceRAndP
    },
    data() {
        return {
            isStopReq: false,
            loading: false,
            dateTimes1: [],
            dateTimes2: [],
            SIdList: [],
            tableCode: 'SupTable',
            dialogApplyVisible: false,
            tagsList: [],
            dialogType: '-1',
            entpCusId: '',
            dialogVisible: false,
            dialogAccountVisible: false,
            showEntityVisible: false,
            dialogSearchVisible: false,
            isShowAdvanceDialog: false,
            EntpCusName: '',
            searchData: {
                Name: '',
                CallNum:'',
                MainPartName: '',
                MainVehicle: '',
                Abbr:'',
                Zone: '',
                Tags: '',
                FollowerId: '',
                StartDate: '',
                EndDate: '',
                UStartDate: '',
                UEndDate: '',
                SortProp: '',
                SortType: '',
                page: 1,
                limit: 15
            },
            tableData: [],
            tableDataLength: 0,
            permission: {},
            columnShowSets: [],
            // 用于供应商列表，分页搜索
            supplierOptions: [],
            supplierForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            isStartSearch: false,
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            saveLoading: false,
            percentage: 0, //进度
            currtPage: 1, //页面，表示保存到第几页,
            saveCount: 0, //已保存数
            showExportMsg: false,
            isShowUpdate: false,
            bacthUpdateData: {
                UpdateKey: '',
                UpdateValue: '',
                SearchData: {},
                CusIds: []
            }
        };
    },
    watch: {
        isStartSearch(newVal, oldVal) {
            if (newVal === true) {
                this.$nextTick(() => {
                    this.$refs.search_sup.focus();
                });
            }
        },
        'bacthUpdateData.UpdateKey'() {
            this.bacthUpdateData.UpdateValue = '';
        }
    },
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        if (this.dialogSearchVisible) this.dialogSearchVisible = false;
        next();
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
        if (this.tableCode) this.getSetsData();
    },
    mounted() {
        this.permission = this.$util.getPermission('supplier');
        this.getTableData();
    },
    filters: {
        stateHandle(value) {
            if (value == 0) {
                return '未询价';
            } else if (value == 1) {
                return '等待报价';
            } else if (value == 2) {
                return '已报价';
            }
        }
    },
    methods: {
        handleKeyEvent(e) {
            let that = this;
            let key = window.event.keyCode;
            if (key === 113) {
                e.preventDefault();
                that.dialogSearchVisible = true;
                that.isStartSearch = true;
                return;
            }
            if (key === 13) {
                e.preventDefault();
                if (that.dialogSearchVisible) {
                    that.handleSearch();
                    that.isStartSearch = false;
                }
                return;
            }
            //F3
            if (key === 114) {
                e.preventDefault();
                that.add(1);
                return;
            }
            if (key === 27) {
                e.preventDefault();
                if (that.dialogSearchVisible) {
                    that.dialogSearchVisible = false;
                    that.isStartSearch = false;
                }
                return;
            }
            //右键
            if (key === 39) {
                e.preventDefault();
                if (!this.dialogSearchVisible) {
                    let page = that.searchData.page;
                    let limit = that.searchData.limit;
                    let totalPages = Math.ceil(that.tableDataLength / limit);
                    if (page < totalPages) {
                        that.searchData.page += 1;
                        that.getTableData();
                    }
                }
                return;
            }
            //左键
            if (key === 37) {
                e.preventDefault();
                if (!that.dialogSearchVisible) {
                    if (that.searchData.page !== 1) {
                        that.searchData.page -= 1;
                        that.getTableData();
                    }
                }
                return;
            }
        },
        // 供应商列表，搜索
        async searchSupplier(key) {
            if (![undefined].includes(key)) {
                this.supplierForm.Page = 1;
                this.supplierForm.stopLoad = false;
                this.supplierForm.key = key;
                this.supplierOptions = [];
            }
            if (this.supplierForm.stopLoad) return;
            const data = await this.$util.searchSupplier(this.supplierForm.key, this.supplierForm.Page, this.supplierForm.Limit);
            if (data) {
                if (!data) return;
                this.supplierForm.stopLoad = data.length < this.supplierForm.Limit;
                this.supplierOptions = [...this.supplierOptions, ...data];
            }
        },
        // 供应商列表，加载更多
        searchSupplierLoad() {
            this.supplierForm.Page += 1;
            this.searchSupplier();
        },
        searchTags() {
            let url = '/api/EntpSuppliers/GetEnterpriseSupplierTagList';
            this.$util
                .axiosGet({
                    url: url,
                    hideLoading: true
                })
                .then(res => {
                    this.tagsList = res.data;
                });
        },
        closeDialog(edit) {
            this.entpCusId = '';
            this.dialogVisible = false;
            this.showEntityVisible = false;
            if (edit) {
                this.getTableData();
            }
        },
        add(type, item) {
            this.entpCusId = '';
            this.dialogType = type;
            if (type == 2 || type == 3) {
                this.entpCusId = item.EntpCusId;
            }
            this.dialogVisible = true;
        },
        // 删除询价
        del(row) {
            let that = this;
            this.$util.elConfirm({
                content: '确定要删除该客户吗？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: '/api/EntpSuppliers/DeleteEnterpriseSupplier',
                            data: {
                                EntpCusId: row.EntpCusId
                            }
                        })
                        .then(() => {
                            that.searchData.page = 1;
                            that.$util.successMsg('删除成功');
                            that.getTableData();
                        });
                }
            });
        },
        payAccount(entpCusId) {
            this.entpCusId = entpCusId;
            this.dialogAccountVisible = true;
        },
        closeAccountDialog() {
            this.supplierData = {};
            this.dialogAccountVisible = false;
        },
        resetSearch() {
            this.searchData = {
                Name: '',
                CallNum:'',
                MainPartName: '',
                MainVehicle: '',
                Abbr:'',
                Zone: '',
                Tags: '',
                FollowerId: '',
                StartDate: '',
                EndDate: '',
                UStartDate: '',
                UEndDate: '',
                SortProp: '',
                SortType: '',
                page: 1,
                limit: this.commonPageSize
            };
            this.dateTimes1 = [];
            this.dateTimes2 = [];
            // this.searchSupplier('');
        },
        getTableData() {
            if (!this.isStopReq) {
                this.loading = true;
                this.isStopReq = true;
                this.$util
                    .axiosGet({
                        url: '/api/EntpSuppliers/GetEnterpriseSupplierList',
                        data: this.searchData,
                        hideLoading: true
                    })
                    .then(res => {
                        let data = res.data;
                        if (!data) data = [];
                        this.tableData = data;
                        if (this.searchData.page == 1) {
                            this.tableDataLength = res.count;
                        }
                    })
                    .catch(() => {})
                    .finally(() => {
                        this.loading = false;
                        this.isStopReq = false;
                    });
            }
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        handleDBClick(event) {
            if (event) {
                this.add(3, event);
            }
        },
        //当客户标签下拉框出现时触发
        tagVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.tagsList.length == 0) that.searchTags();
            }
        },
        gotoImportPage() {
            this.$router.push('/purchaseManage/supplierManage/importExcel?cType=1');
        },
        applyAdvancePayment(item) {
            if (item) {
                this.EntpCusId = item.EntpCusId;
                this.EntpCusName = item.Name;
            } else {
                this.EntpCusId = '';
                this.EntpCusName = '';
            }
            this.dialogApplyVisible = true;
        },
        closeApplyDialog() {
            this.dialogApplyVisible = false;
        },
        entityMerge() {
            this.showEntityVisible = true;
        },
        getSetsData() {
            this.columnShowSets = [];
            this.$util.getTBSetsForShow(this.tableCode).then(data => {
                data.forEach(item => {
                    let colums = {
                        IsShow: item.IsShow,
                        Width: item.Width,
                        ColumnName: item.ColumnName,
                        ColumnCode: item.ColumnCode,
                        SortNum: item.SortNum,
                        IsSort: item.IsSort
                    };

                    this.columnShowSets.push(colums);
                });
            });
        },
        showSearchDialog() {
            this.dialogSearchVisible = true;
            this.isStartSearch = true;
        },
        closeSearchDialog() {
            this.dialogSearchVisible = false;
            this.isStartSearch = false;
            // this.resetSearch();
        },
        showApplyAdvance() {
            this.isShowAdvanceDialog = true;
        },
        closeAdvanceDialog() {
            this.isShowAdvanceDialog = false;
        },
        onDate1TimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        onDate2TimeSelect(val) {
            if (val != null) {
                this.searchData.UStartDate = val[0];
                this.searchData.UEndDate = val[1];
            } else {
                this.searchData.UStartDate = '';
                this.searchData.UEndDate = '';
            }
        },
        getSIdList() {
            this.$util.getCommonSIdList().then(data => {
                this.SIdList = data;
            });
        },
        staffVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.SIdList.length == 0) that.getSIdList();
            }
        },
        // 导出
        exportForm() {
            let that = this;
            this.$util.elConfirm({
                content: '确定导出供应商明细表吗？',
                noMsg: true,
                confirm() {
                    that.exportData();
                }
            });
        },
        exportData() {
            let that = this;
            if (that.tableData.length == 0) {
                that.$util.warningMsg('请筛选数据');
                return;
            }
            that.saveLoading = true;
            let saveLimit = 100;
            if (that.tableDataLength < saveLimit) saveLimit = that.tableDataLength;

            let reqData = { ...that.searchData };
            reqData._Limit = saveLimit;
            reqData._Page = that.currtPage;

            that.$util
                .axiosGet({
                    url: '/api/EntpSuppliers/GetEntpSupListToExport',
                    data: reqData,
                    hideLoading: true
                })
                .then(resp => {
                    that.saveCount += saveLimit;
                    let num = parseFloat(that.saveCount);
                    let total = parseFloat(that.tableDataLength);
                    that.percentage = total <= 0 ? 0 : Math.round(Math.round((num / total) * 10000) / 100.0);
                    that.percentage = that.percentage > 100 ? 100 : that.percentage;
                    if (that.tableDataLength <= that.saveCount) {
                        that.showExportMsg = true;
                        that.$util
                            .exportFile({
                                url: '/api/EntpSuppliers/ExportEntpSups'
                            })
                            .then(res => {
                                that.percentage = 0;
                                that.saveCount = 0;
                                that.currtPage = 1;
                                that.saveLoading = false;
                                that.showExportMsg = false;
                                that.$util.successMsg('导出成功');
                            });
                    } else {
                        that.currtPage++;
                        that.exportData();
                    }
                })
                .catch(() => {
                    that.percentage = 0;
                    that.saveCount = 0;
                    that.currtPage = 1;
                    that.saveLoading = false;
                });
        },
        bacthUpdate() {
            let that = this;
            if (that.bacthUpdateData.CusIds.length == 0) {
                that.$confirm('未选择批量更新的供应商，是否将所有筛选结果进行更新？如果数据过多可能耗时稍长', '提醒', {
                    type: 'error',
                    distinguishCancelAndClose: true
                })
                    .then(() => {
                        that.isShowUpdate = true;
                    })
                    .catch(() => {
                        return;
                    });
            } else that.isShowUpdate = true;
        },
        handleSelectionChange(val) {
            let idList = [];
            for (let i = 0; i < val.length; i++) {
                idList.push(val[i].EntpCusId);
            }
            this.bacthUpdateData.CusIds = idList;
        },
        getRowKey(row) {
            return row.EntpCusId;
        },
        confirmUpdate() {
            let that = this;
            if (!that.bacthUpdateData.UpdateKey) {
                that.$util.warningMsg('请选择要修改项');
                return;
            }
            if (!that.bacthUpdateData.UpdateValue) {
                that.$util.warningMsg('请填写结果值');
                return;
            }
            that.bacthUpdateData.SearchData = that.searchData;
            that.loading = true;
            that.$util
                .axiosPost({
                    url: '/api/EntpSuppliers/BacthUpdateData',
                    data: that.bacthUpdateData,
                    hideLoading: true
                })
                .then(resp => {
                    if (resp.errcode == 0) {
                        that.$util.successMsg('批量修改成功');
                        that.getTableData();
                        that.closeUpdateDialog();
                    }
                })
                .finally(() => {
                    that.loading = false;
                });
        },
        isExObj(str) {
            let index = this.columnShowSets.findIndex(item => item.ColumnCode === str);
            return index > -1;
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.page = 1;
            this.getTableData();
        },
        closeUpdateDialog() {
            this.isShowUpdate = false;
            this.bacthUpdateData.CusIds = [];
            this.bacthUpdateData.UpdateKey = '';
            this.bacthUpdateData.UpdateValue = '';
            this.$refs.multipleTable.clearSelection();
        }
    }
};
</script>
<style lang="less" scoped>
#search-sup-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .search-item-dialog {
        width: 340px;
        height: auto;
        .dialog-footer {
            text-align: right;
        }
        .el-form-item {
            margin-bottom: 0;
        }
    }
    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
#apply-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .search-item-dialog {
        width: 340px;
        height: auto;
        .dialog-footer {
            text-align: right;
        }
        .el-form-item {
            margin-bottom: 0;
        }
    }
    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
    .saveProgress {
        position: absolute;
        top: 45%;
        left: 45%;
        z-index: 9999;
    }
    .exportmsg {
        display: flex;
        flex-direction: column;
        align-items: center;
        z-index: 10000;
        position: absolute;
        top: 65vh;
        left: 60vh;
        font-size: 22px;
        color: rgb(243, 62, 62);
    }
}
</style>
<style lang="less">
.e-item1 {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 30%;
}
.e-item2 {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 70%;
}
</style>
